import {Component, inject, OnInit} from '@angular/core';
import {UtilsService} from '@services/utils.service';


@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnInit{
  utilsSvc = inject(UtilsService)
  loading: boolean = false;
  constructor(
  ) {
    }

  ngOnInit() {
    this.loading = this.utilsSvc.isLoading()
  }

}
